import $ from "jquery";

const aboutussublink = {
    variable: {
        url: window.location.href,
    },
    methods: {
        sublinkButtonClickHandler: function () {
            $('.navbar__item').on('click', function(e) {
                var obj = aboutussublink.methods.dataLayerObj(e);
                createDataLayer('buttonClick', obj);
            });
        },
        dataLayerObj: function (e) {
            var obj = {
                'articleName': "",
                'blogCategory': "",
                'blogPageCategory': "",
                'buttonText': e.currentTarget.innerText.replace(/\n/g, '').trim(),
                'pageSection': "About Us Tabs",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? aboutussublink.variable.url.includes("blog") ? "Blogs" : aboutussublink.variable.url.substring(aboutussublink.variable.url.indexOf(".com/"), aboutussublink.variable.url.lastIndexOf('/')  === ".com") && !aboutussublink.variable.url.substring(aboutussublink.variable.url.indexOf(".com/"), aboutussublink.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption': "",
                'productCategory': "",
                'productName': "",
                'question': "",
                'source': "",
                'searchTerm': "",
                'videoTitle': "",
                'bannerName': "",
            };
            return obj;
        }
    }
};

$(document).ready(function () {
    aboutussublink.methods.sublinkButtonClickHandler();

    const activeLink = document.querySelector('.navbar__link.active');
    if (activeLink) {
        activeLink.scrollIntoView({ inline: 'center', block: 'nearest' });
    }
});
